
//global container for highchart visuals
window.__GLOBAL_VISUAL_LIST = {};

function vcVisual() {
    this.service = window.VisualCoreService;
    this.showHeaderFields = true;
    this.showHeaderMenu = true;
    this.showHeaderBar = true;
    this.showSettings = true;
    this.showFullscreen = true;
    this.cmd = "";
}

vcVisual.prototype.destroyRampChart = function (vcgid) {
      /// <summary>
        /// This function destroys a highchart object from the global visual list
        /// </summary>
    try {

        if (typeof (window.__GLOBAL_VISUAL_LIST["ramp" + vcgid]) !== "undefined") {
        
            if (typeof (window.__GLOBAL_VISUAL_LIST["ramp" + vcgid].renderer) !== "undefined") {
                window.__GLOBAL_VISUAL_LIST["ramp" + vcgid].destroy();
            }

        }
    } catch (ex) { writeError("vcVisuals.JS.destroyRampChart", ex);}
};


vcVisual.prototype.setShowHeaderFields = function (show) {
    this.showHeaderFields = show;
};

vcVisual.prototype.setShowHeaderBar = function (show) {
    this.showHeaderBar = show;
};

vcVisual.prototype.setShowHeaderMenu = function (show) {
    this.showHeaderMenu = show;
};

vcVisual.prototype.setShowSettings = function (show) {
    this.showSettings = show;
};

vcVisual.prototype.setShowFullscreen = function (show) {
    this.showFullscreen = show;
};

vcVisual.prototype.setCmd = function (cmd) {
    this.cmd = cmd;
};

vcVisual.prototype.addVisual = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError, blid) {
    try {
        var visual = this;
        blid = (typeof blid !== "undefined") ? blid : -1;
        window.VisualCoreService.getVisual(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,blid,
        function (result) {

            //redirect to logout if user is not authenticated
            if (visual.validLogin(result) === false) { return false };

            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof(callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisual", ex); }
};

vcVisual.prototype.addVisualByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {

     

        var visual = this;
        window.VisualCoreService.getVisualByName(name, vcgid, date, height, width, parameter, signalparameter, devicetype,
            function (result) {
              
            //redirect to logout if user is not authenticated
            if (visual.validLogin(result) === false) { return false };
          
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof(callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        }
     );
    } catch (ex) {

       // console.info(ex);
        ex.description += "-vcgid:" + vcgid + ";p:" + parameter + "sp:" + signalparameter + "d:" + date + "errNr:" + ex.number; writeError("vcVisuals.JS.addVisualByName", ex);
    }
};

vcVisual.prototype.addRampByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {

        this.destroyRampChart(vcgid);
        this.addVisualByName(container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError);
        
    } catch (ex) { writeError("vcVisuals.JS.addRampByName", ex); }
};

vcVisual.prototype.addVisualBase = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError,blid) {
    try {
        var visual = this;
        blid = (typeof blid !== "undefined") ? blid : -1;
        window.VisualCoreService.getVisualBase(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, blid,
        function (result) {

            ////redirect to logout if user is not authenticated
            //if (visual.validLogin(result) === false) {
            //    console.info("validlogin");
            //    return false;
            //};

            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof(callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisualBase", ex); }
};


vcVisual.prototype.addVisualBaseByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {

        var visual = this;
        window.VisualCoreService.getVisualBaseByName(name,
            vcgid,
            date,
            height,
            width,
            parameter,
            signalparameter,
            devicetype,
            function (result) {
              
                //redirect to logout if user is not authenticated
                if (visual.validLogin(result) === false) {
                    console.info("invalidlogin");
                    return false;
                };
               
                $("#" + container + vcgid).html(result);
                eval($("#" + container + vcgid));
                visual.setOptions($("#" + container + vcgid));
                visual = null;
                if (typeof(callback) !== "undefined") {
                    callback(container, vcgid);
                }
                return false;
            },
            function (error) {
             
                if (typeof (error) !== "undefined") {
                    if (typeof (onError) !== "undefined") {
                        console.info("onerror");
                        return onError(error);
                    };
                };
            }
        );
    } catch (ex) {
        writeError("vcVisuals.JS.addVisualBaseByNameCallback", JSON.stringify(arguments));
         writeError("vcVisuals.JS.addVisualBaseByNameCallback", ex);
    }
};

vcVisual.prototype.addRampBaseByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {


        this.destroyRampChart(vcgid);
        this.addVisualBaseByName(container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError);
    } catch (ex) {
        writeError("vcVisuals.JS.addRampBaseByName", ex);
    }
};

vcVisual.prototype.addVisualContent = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError, blid) {
    try {
        var visual = this;
        blid = (typeof blid !== "undefined") ? blid : -1;
        window.VisualCoreService.getVisualContent(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,blid,
            function (result) {

                //redirect to logout if user is not authenticated
                if (visual.validLogin(result) === false) { return false };

                $("#" + container + vcgid).html(result);
                eval($("#" + container + vcgid));
                visual.setOptions($("#" + container + vcgid));
                visual = null;
                if (typeof (callback) !== "undefined") {
                    callback(container, vcgid);
                }
                return false;
            }, function (error) {
                if (typeof (onError) !== "undefined") { return onError(error) };
            },
           
        );
    } catch (ex) { writeError("vcVisuals.JS.addVisualContent", ex); }
};

vcVisual.prototype.addVisualContentByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualContentByName(name, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            //redirect to logout if user is not authenticated
            if (visual.validLogin(result) === false) { return false };

            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof(callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        }
        );
    } catch (ex) { writeError("vcVisuals.JS.addVisualContentByName", ex); }
};







vcVisual.prototype.addVisualLegend = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualLegend(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof (callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisualLegend", ex); }
};


vcVisual.prototype.addVisualLegendByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype, callback, onError) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualLegendByName(name, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            if (typeof (callback) !== "undefined") {
                callback(container, vcgid);
            }
            return false;
        }, function (error) {
            if (typeof (onError) !== "undefined") { return onError(error) };
        }
        );
    } catch (ex) { writeError("vcVisuals.JS.addVisualLegendByName", ex); }
};




vcVisual.prototype.addVisualHeader = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualHeader(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            return false;
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisualHeader", ex); }
};



vcVisual.prototype.addVisualHeaderByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualHeaderByName(name, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            visual = null;
            return false;
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisualHeaderByName", ex); }
};






vcVisual.prototype.getVisualValidation = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualValidation(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            visual = null;
            return result;
        });
    } catch (ex) {
        writeError("vcVisuals.JS.getVisualValidation", ex);
    }
};

vcVisual.prototype.getVisualValidationByName = function (container, name, vcgid, date, height, width, parameter, signalparameter, devicetype) {
    try {
        var visual = this;
        window.VisualCoreService.getVisualValidationByName(name, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            visual = null;
            return result;
        });
    } catch (ex) {
        writeError("vcVisuals.JS.getVisualValidationByName", ex);
    }
};

vcVisual.prototype.addVisualInFrame = function (container, vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype, debug) {
    try {
        var visual = this;
        var start = new Date().getTime();
        window.VisualCoreService.getVisual(vcvid, vcgid, date, height, width, parameter, signalparameter, devicetype,
        function (result) {
            $("#" + container + vcgid).html(result);
            eval($("#" + container + vcgid));
            visual.setOptions($("#" + container + vcgid));
            var elapsed = new Date().getTime() - start;
            if (debug) {
                $("#" + container + vcgid).append(visual.showDebug(container, vcgid, elapsed));
            }
            visual = null;
            start = null;
            return false;
        });
    } catch (ex) { writeError("vcVisuals.JS.addVisualInFrame", ex); }
};


vcVisual.prototype.getExportByName = function (name, vcgid, date, height, width, parameter, signalparameter, devicetype, exportParameter, callback, onError) {
    try {

        var visual = this;
        window.VisualCoreService.exportDataByName(name,
            vcgid,
            date,
            height,
            width,
            parameter,
            signalparameter,
            devicetype,
            exportParameter,
            function (result) {

                //redirect to logout if user is not authenticated
                if (visual.validLogin(result) === false) {
                    return null;
                };

                return    callback(result);
            },
            function (error) {

                if (typeof (error) !== "undefined") {
                    if (typeof (onError) !== "undefined") {
                        return onError(error);
                    };
                };
            }
        );
    } catch (ex) {
        writeError("vcVisuals.JS.getExportByName", ex);
    }
};











vcVisual.prototype.showSignalInfoPopup = function (bsaid, tecDet, date, height, width, devicetype) {
    try {
        var visual = this;
        showModalPopup("<div id='SignalAnalogInfo0'></div>", width, height);
        window.VisualCoreService.getVisualContent(184, "SignalAnalogInfo0", date, height-20, width-5, "", JSON.stringify({ 'tecDet': tecDet, 'bsaid': bsaid }), devicetype,
        function (result) {
            $("#SignalAnalogInfo0").html(result);
            eval($("#SignalAnalogInfo0"));
            visual.setOptions($("#SignalAnalogInfo0"));
            visual = null;
            return false;
        });
    } catch (ex) { writeError("vcVisuals.JS.showSignalInfoPopup", ex); }
};



vcVisual.prototype.showSignalAnalogSummaryDialog = function (bsaid) {
    /// <summary>
    /// This function opens a system-wide popup and shows the signal analog summary. 
    /// The width and height is fixed - otherwise we get too many problems with the different menu points in the summary popup.
    /// </summary>
    try {
        var  popup = $("<div>").attr("id", "popupDialog");
        var visual = this;
     
        popup.dialog({
            autoOpen: true,
            modal: true,
            width:1030,
            height:800,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+5%', at: 'top', of: window },
           
            buttons: [{
            text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                popup.dialog('close');
                return true;
            } }]
        });

        window.VisualCoreService.getVisualContentByName("VISUAL_SIGNALANALOG_SUMMARY",
            parseInt(Math.random() * 100000, 10),getCurrentTimestamp(),700,1030, "", JSON.stringify({ 'bsaid': bsaid }), 2,
            function(result) {
                //redirect to logout if user is not authenticated
                if (visual.validLogin(result)) {
                    popup.html(result);
                    eval(popup);
                };
            },
            function() {
                if (typeof (onError) !== "undefined") {
                    return onError(error);
                };
                return true;
            }
            );

    } catch (ex) { writeError("vcVisuals.JS.showSignalAnalogSummaryDialog", ex); }
};


vcVisual.prototype.showProjectSummaryDialog = function (blid) {
    /// <summary>
    /// This function opens a system-wide popup and shows the signal analog summary. 
    /// The width and height is fixed - otherwise we get too many problems with the different menu points in the summary popup.
    /// </summary>
    try {
        var popup = $("<div>").attr("id", "popupDialog");
        var visual = this;

        popup.dialog({
            autoOpen: true,
            modal: true,
            width: 1150,
            height: 880,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+5%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });

        window.VisualCoreService.getVisualContentByName("VISUAL_PROJECT_SUMMARY",
            parseInt(Math.random() * 100000, 10), getCurrentTimestamp(), 750, 950, JSON.stringify({ 'loggerid': blid }), "", 2,
            function (result) {
                //redirect to logout if user is not authenticated
                if (visual.validLogin(result)) {
                    popup.html(result);
                    eval(popup);
                };
            },
            function () {
                if (typeof (onError) !== "undefined") {
                    return onError(error);
                };
                return true;
            }
            );

    } catch (ex) { writeError("vcVisuals.JS.showProjectSummaryDialog", ex); }
};


vcVisual.prototype.showSignalTicketDialog = function (blid,bsaid) {
    /// <summary>
    /// This function opens a system-wide popup and shows a list of tickets 
    /// The width and height is fixed - otherwise we get too many problems with the different menu points in the summary popup.
    /// </summary>
    try {
        var popup = $("<div>").attr("id", "popupDialog").addClass("yform");
        var visual = this;

        popup.dialog({
            autoOpen: true,
            modal: true,
            width: 1200,
            height: 850,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+5%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });


        window.VisualCoreService.getVisualBaseByName("VISUAL_OPERATION_ENTRIES",
            parseInt(Math.random() * 100000, 10), getCurrentTimestamp(), 770, 1200,  JSON.stringify({ "ReadOnlyMode": true, 'SignalID': bsaid, "LoggerID" :blid }),"", 2,
            function (result) {
                //redirect to logout if user is not authenticated
                if (visual.validLogin(result)) {
                    popup.html(result);
                    eval(popup);
                };
            },
            function () {
                if (typeof (onError) !== "undefined") {
                    return onError(error);
                };
                return true;
            }
        );

    } catch (ex) { writeError("vcVisuals.JS.showSignalTicketDialog", ex); }
};


vcVisual.prototype.showSingleTicketDialog = function (blid, param) {
    /// <summary>
    /// This function opens a system-wide popup and shows a list of tickets 
    /// The width and height is fixed - otherwise we get too many problems with the different menu points in the summary popup.
    /// </summary>
    try {
        var popup = $("<div>").attr("id", "popupDialog").addClass("yform");
        var visual = this;


        $("body").on("Trigger-singleTicket-closed", function (e) {
            popup.html("");
            popup.remove();
        });

        popup.dialog({
            autoOpen: true,
            modal: true,
            width: 1200,
            height: 910,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+5%', at: 'top', of: window },

        });
        popup.removeClass("yform");
        popup.css("margin-top", 0).css("overflow", "hidden");
        popup.siblings(".ui-dialog-titlebar").hide();

        var w = parseInt(popup.width()) - 2;
        //console.info("TICKET-popup: " + w);
        popup.css("width", w);
        //console.info("TICKET-popup: " + popup.width());
       
        popup.Ticket({ invokeType: "addVisualBase", blid: blid, parameter: param }); 

    } catch (ex) { writeError("vcVisuals.JS.showSingleTicketDialog", ex); }
};



vcVisual.prototype.showDsEdit2Dialog = function (param) {
    /// <summary>
    /// This function opens a system-wide popup and shows the datacenter data editor
    /// </summary>
    try {
        var h = 0, w = 0;
      
        //get the windows height for our popup
        h = $(window).height();
        if (h === 0) {
            h = $(document).height();
            if (h === 0) {
                h = document.body.scrollHeight;
            }
        }
        w = parseInt($(window).width() * 0.97);
        h = parseInt(h * 0.95);
      
        var popup = $("<div>").attr("id", "popupDsEdit21Dialog");
        popup.css("overflow-y", "hidden");
      
        popup.dialog({
            open: function (event, ui) { popup.DsEdit2({ invokeType: "addVisualBase", parameter: param }) },
            close: function (event, ui) {
                var val = '';
                if (param.ArchVcgid != undefined) { val = param.ArchVcgid; }

                // if popup is opened in archive, archive vcgid is sent back and checked in vcMenuTemplate, if vcMQ message is coming from the current archive or a different one; otherwise val = empty
                _VCMQ.produce(popup, -1, 'DSEDIT_CLOSE', val);
                popup.DsEdit2("destroy");

                popup.empty();  // remove content of popup                
                popup.dialog('destroy'); // destroy instance
                popup.removeData().remove(); // remove jQuery data and DOM element

            },
           
            autoOpen: true,
            modal: true,
            width: w,
            height: h,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+2%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });
     
      
   
        //popup.height(h+10);



    } catch (ex) { writeError("vcVisuals.JS.showDsEdit2Dialog", ex); }
};


vcVisual.prototype.showSignalSelectionPopup = function (param) {
    /// <summary>
    /// This function opens a system-wide popup and shows the signal selection
    /// </summary>
    try {
        var h = 0, w = 0;

        //get the windows height for our popup
        h = $(window).height();
        if (h === 0) {
            h = $(document).height();
            if (h === 0) {
                h = document.body.scrollHeight;
            }
        }
        w = parseInt($(window).width() * 0.8);
        h = parseInt(h * 0.8);

        var popup = $("<div>").attr("id", "popupSignalSelectionDialog");
        popup.css("overflow-y", "hidden");

        popup.dialog({
            open: function (event, ui) { popup.SignalSelectionPopup({ invokeType: "addVisualBase", parameter: param }) },
            close: function (event, ui) {

                popup.SignalSelectionPopup("destroy");

                popup.html("");
                popup.remove();
            },

            autoOpen: true,
            modal: true,
            width: w,
            height: h,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+2%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });

        return popup;

    } catch (ex) { writeError("vcVisuals.JS.showSignalSelectionPopup", ex); }
};

vcVisual.prototype.showRampArchiveSimplePopup = function (param) {
    /// <summary>
    /// This function opens a system-wide popup and shows the signal selection
    /// </summary>
    try {
        var h = 0, w = 0;

        //get the windows height for our popup
        h = $(window).height();
        if (h === 0) {
            h = $(document).height();
            if (h === 0) {
                h = document.body.scrollHeight;
            }
        }
        w = parseInt($(window).width() * 0.9);
        h = parseInt(h * 0.9);

        var popup = $("<div>").attr("id", "popupSignalSelectionDialog");
        popup.css("overflow-y", "hidden");

        popup.dialog({
            open: function (event, ui) { popup.RampArchiveSimple({ invokeType: "addVisualBase", parameter: param }) },
            close: function (event, ui) {

                popup.RampArchiveSimple("destroy");

                popup.html("");
                popup.remove();
            },

            autoOpen: true,
            modal: true,
            width: w,
            height: h,
            resizable: false,
            dialogClass: "modal-popup-dialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+2%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });

        return popup;

    } catch (ex) { writeError("vcVisuals.JS.showRampArchiveSimple", ex); }
};




vcVisual.prototype.showDebug = function (container, vcgid, time) {
    try {
        var h = $("#" + container + vcgid).height();
        var w = $("#" + container + vcgid).width();
        var len = $("#" + container + vcgid).html().length;
        var sTmp = "<div style='position:absolute; top:" + (h - 23) + "px; height:18px;width:" + (w - 10) + "px;background-color:#dddddd' class='frame round'>";
        sTmp += "h=" + h + ";w=" + w + ";len=" + len + ";ms=" + time;
        sTmp += "</div>";
        return sTmp;
    } catch (ex) { writeError("vcVisuals.JS.showDebug", ex); return ""}
};

vcVisual.prototype.setOptions = function (div) {
    try {
        if (this.showHeaderMenu === false) {
            div.find('.imgHeaderMenu').hide();
        }
        if (this.showSettings === false) {
            if (div.find('.btnHelp').length === 0) {
                div.find('.imgHeaderMenu').hide();
            } else {
                div.find('.btnSettings').hide();
            }
        }
        if (this.showFullscreen === false) {
            div.find('.imgFullscreen').hide();
        }

        if (this.showHeaderFields === false) {
            div.find('.widget-header-fields').hide();
        }
        if (this.cmd.length > 0) {
            eval(this.cmd);
        }
        if (this.showHeaderBar === false) {
            div.find('.widget-header').hide();
        }
    } catch (ex) { writeError("vcVisuals.JS.setOptions", ex); }
};

vcVisual.prototype.validLogin = function (result) {
    try {
        if (result === "ERR_INVALIDLOGIN") {
            location.reload();
            return false;
        }
        return true;
    } catch (ex) {
        writeError("vcVisuals.JS.validLogin", ex);
        return false;
    }
};



